import { render, staticRenderFns } from "./Usage.vue?vue&type=template&id=6a70402f&scoped=true"
import script from "./Usage.vue?vue&type=script&lang=js"
export * from "./Usage.vue?vue&type=script&lang=js"
import style0 from "./Usage.vue?vue&type=style&index=0&id=6a70402f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a70402f",
  null
  
)

export default component.exports